<template>
  <div v-show="initialized" class="sub-header">
    <div class="sub-header--container">
      <div class="hearing-aid-sales__filters">
        <div class="filter-sales-dates__report filter-selection">
          <div class="filter-selection__title">Report:</div>
          <div class="filter-selection__body">
            <StoreConnectedSelect
                class="filter-selection__select"
                :store="store"
                action="setReport"
                :name="name"
                sub-prop="flashReportName"
                placeholder="Reports"
                :options="reportsList"
                options-label="name"
                options-value="name">
            </StoreConnectedSelect>
          </div>
        </div>

        <div class="filter-products__vendor filter-selection">
          <div class="filter-selection__title">Vendor:</div>
          <div class="filter-selection__body">
            <StoreConnectedSelect
                class="filter-selection__select"
                :store="store"
                :action="action"
                :name="name"
                sub-prop="vendor"
                placeholder="Vendors"
                :options="vendorsList" multiple clear-button>
            </StoreConnectedSelect>
          </div>
        </div>

        <div class="filter-products__tier filter-selection">
          <div class="filter-selection__title">Tier:</div>
          <div class="filter-selection__body">
            <StoreConnectedSelect
                class="filter-selection__select"
                :store="store"
                :action="action"
                :name="name"
                sub-prop="tier"
                placeholder="Tiers"
                :options="tiersList" multiple clear-button>
            </StoreConnectedSelect>
          </div>
        </div>

        <div class="filter-products__promo filter-selection">
          <div class="filter-selection__title">Promo:</div>
          <div class="filter-selection__body">
            <StoreConnectedSelect
                class="filter-selection__select"
                :store="store"
                :action="action"
                :name="name"
                sub-prop="promo"
                placeholder="Promos"
                :options="promosList" multiple clear-button>
            </StoreConnectedSelect>
          </div>
        </div>

        <div class="hearing-aid-sales__commands" v-if="!loading">
          <a href="#" class="btn btn-success hearing-aid-sales__btn-run" @click.prevent="update">Run Report</a>
        </div>
      </div>
    </div> <!-- END container -->
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min';
  import StoreConnectedDatePicker from '../form-items/StoreConnectedDatePicker.vue';
  import StoreConnectedSelect from '../form-items/StoreConnectedSelect.vue';

  export default {
    name: 'SalesFilters',
    components: {
      MoonLoader,
      StoreConnectedDatePicker,
      StoreConnectedSelect,
    },
    data() {
      return {
        store: 'purchaseActivityFlash',
        action: 'setFilter',
        name: 'filters',
        loading: true,
        initialized: false,
      }
    },
    async mounted() {
      //await this.$store.dispatch('purchaseActivityFlash/getDateList');
      await this.$store.dispatch('purchaseActivityFlash/getReports');
      //await this.$store.dispatch('purchaseActivityFlash/getProducts');
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
      this.loading = false;
      this.initialized = true;
      this.getData();
    },
    computed: {
      ...mapGetters('purchaseActivityFlash', [
        'filters',
        'initialValues',
        'reportsList',
        'vendorsList',
        'tiersList',
        'productsList',
        'promosList',
      ]),
      // compDateTo() {
      //   return moment(this.dateTo).toDate();
      // },
      // compDateFrom() {
      //   return moment(this.dateFrom).toDate();
      // },
    },
    watch: {
      // disabledRangeFrom() {
      //   if (this.compDateFrom < this.disabledRangeFrom.to) {
      //     this.$store.dispatch('purchaseActivityFlash/setFilter', { key: 'dateFrom', value: this.disabledRangeFrom.to });
      //   }
      //   if (this.compDateFrom > this.disabledRangeFrom.from) {
      //     this.$store.dispatch('purchaseActivityFlash/setFilter', { key: 'dateFrom', value: this.disabledRangeFrom.from });
      //   }
      // },
      // disabledRangeTo() {
      //   if (this.compDateTo < this.disabledRangeTo.to) {
      //     this.$store.dispatch('purchaseActivityFlash/setFilter', { key: 'dateTo', value: this.disabledRangeTo.to });
      //   }
      //   if (this.compDateTo > this.disabledRangeTo.from) {
      //     this.$store.dispatch('purchaseActivityFlash/setFilter', { key: 'dateTo', value: this.disabledRangeTo.from });
      //   }
      // },
    },
    methods: {
      async update() {
        await this.$store.dispatch('purchaseActivityFlash/cancelAjax');
        this.getData();
      },
      getData() {
        this.$store.dispatch('purchaseActivityFlash/getData');
      },
    },
  };
</script>
